import { render } from "./ProgrammeBanner.vue?vue&type=template&id=45e6d016&scoped=true"
import script from "./ProgrammeBanner.vue?vue&type=script&lang=js"
export * from "./ProgrammeBanner.vue?vue&type=script&lang=js"

import "./ProgrammeBanner.vue?vue&type=style&index=0&id=45e6d016&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e6d016"]])

export default __exports__